var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLeaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 42,
    fill: "#EB2019"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0636 23.5478C22.2001 23.2163 22.5245 23 22.8826 23C57.2858 23 61 37.2576 61 43.3883C61 51.3415 54.9437 56.6851 45.9304 56.6851C34.5466 56.6851 32.162 45.8526 30.8802 40.034C29.157 32.1995 25.3647 27.6254 22.255 24.514C22.0016 24.2605 21.9253 23.8793 22.0636 23.5478ZM32.6124 39.6528C34.2381 47.0352 36.7397 54.9122 45.9304 54.9122C53.8836 54.9122 59.2271 50.2813 59.2271 43.3883C59.2271 37.9118 55.8374 25.3331 24.9747 24.7906C27.9053 28.0155 31.0557 32.5701 32.6124 39.6528Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2681 32.3583C36.4825 31.9186 37.0127 31.736 37.4524 31.947C51.8607 38.9288 61 55.8404 61 61.1112C61 61.6005 60.6028 61.9977 60.1135 61.9977C59.6242 61.9977 59.227 61.6005 59.227 61.1112C59.227 56.9679 51.2295 40.5934 36.6793 33.5427C36.2397 33.3282 36.0553 32.798 36.2681 32.3583Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeaf);
export default __webpack_public_path__ + "static/media/icon-leaf.f0b613199fb77b6634093ca4697fe534.svg";
export { ForwardRef as ReactComponent };